import React, { useMemo } from 'react';
import SearchBar from './SearchBar';
import TableListItem from './TableListItem';
import { ErrorMessage } from '../../Common/ErrorMessage/ErrorMessage';
import './TableList.css';

/**
 * Table List Component
 * Displays searchable list of tables with create functionality
 */
const TableList = ({
  tables = [],
  searchTerm = '',
  onSearchChange,
  onTableClick,
  onCreateTable,
  onDeleteTable,
  permissions = {},
  isLoading = false,
  error = null,
  className = ''
}) => {
  // Filter tables by search term
  const filteredTables = useMemo(() => {
    if (!searchTerm) return tables;
    
    return tables.filter((table) =>
      table.table_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [tables, searchTerm]);

  if (isLoading) {
    return (
      <div className={`table-list-wrapper ${className}`}>
        <div className="table-list-loading">
          Loading tables...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`table-list-wrapper ${className}`}>
        <ErrorMessage message={error} />
      </div>
    );
  }

  return (
    <div className={`table-list-wrapper ${className}`}>
      <SearchBar
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        onCreateTable={onCreateTable}
        canCreate={permissions.canCreate}
        disabled={permissions.isRestricted}
      />
      
      {filteredTables.length === 0 ? (
        <div className="table-list-empty">
          {searchTerm ? (
            <>
              <h4>No tables found</h4>
              <p>No tables match your search "{searchTerm}"</p>
            </>
          ) : (
            <>
              <h4>No tables available</h4>
              <p>Create your first table to get started</p>
            </>
          )}
        </div>
      ) : (
        <ul className="template-list">
          {filteredTables.map((table) => (
            <TableListItem
              key={table.id || table.table_name}
              table={table}
              onClick={onTableClick}
              onDelete={onDeleteTable}
              canDelete={permissions.canDelete}
              disabled={permissions.isRestricted}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default TableList;
